import type { FC } from 'react';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { UnavailableContainer, UnavailableText } from './UnavailableContent.styles';

export const UnavailableContent: FC = () => {
    const theme = useInterstateTheme();

    return (
        <UnavailableContainer theme={theme} data-testid="alt-deal-cell-unavailable">
            <UnavailableText theme={theme} variant="body-sm">
                Rate unavailable
            </UnavailableText>
        </UnavailableContainer>
    );
};
